import { render } from "./Support-upload-document-list.vue?vue&type=template&id=eae0366e"
import script from "./Support-upload-document-list.vue?vue&type=script&lang=ts"
export * from "./Support-upload-document-list.vue?vue&type=script&lang=ts"
script.render = render

export default script